import { Component, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from "primeng/card";
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { Login as LoginService } from '../../services/login';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputOtpModule,
    MessageModule,
    ToastModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    CardModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [MessageService]
})
export class LoginComponent {
  protected messageService = inject(MessageService);
  protected loginService = inject(LoginService);
  protected emailForm: FormGroup;
  protected pinForm: FormGroup;
  protected email: string = '';
  protected formSubmitted: boolean = false;
  protected state: 'email' | 'pin' = 'email';

  constructor(private fb: FormBuilder) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
    this.pinForm = this.fb.group({
      pin: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  protected async onSubmit() {
    this.formSubmitted = true;
    if (this.state === 'pin' && this.pinForm.valid) {
      try {
        this.loginService.validateFactor2(this.pinForm.get("pin")?.value);
        this.formSubmitted = false;
      } catch (e) {
        this.messageService.add({ severity: "error", summary: "Fehler", detail: "Es ist ein Fehler aufgetreten." })
        this.state = 'email';
      }
    }
  }

  protected isInvalid(controlName: string) {
    let control: AbstractControl | null;
    if (controlName === 'email') {
      control = this.emailForm.get(controlName);
    } else {
      control = this.pinForm.get(controlName);
    }
    return control?.invalid && (control.dirty || control.touched || this.formSubmitted);
  }

  protected onNext() {
    if (this.state === 'email' && this.emailForm.valid) {
      try {
        this.loginService.loginWithEmail(this.emailForm.get("email")?.value);
        this.state = 'pin';
      } catch (e) {
        this.messageService.add({ severity: "error", summary: "Fehler", detail: "Es ist ein Fehler aufgetreten." })
      }
    }
  }
}
